import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class CSVMov extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            csv: 'Vazio!',
        };
    }

    componentDidMount = async () => {
        this.atualizarCsv();
    }

    atualizarCsv = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/movimentacoesCSV`);
            const csv = res.data.csv.replace(/\./g, ',');

            this.setState({ csv });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <table className="table table-hover table-bordered">
                <thead className="thead-inverse">
                    <tr>
                        <th>CSV</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.csv.split('\n').map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item}</td>
                            </tr>);
                    })}
                </tbody>
            </table>
        );
    }
}

CSVMov.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired,
};

function mapStateToProps({ filtro }) {
    return {
        filtro: filtro
    };
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSVMov);



// WEBPACK FOOTER //
// ./src/components/MovAtivo/CSVMov.js